/* eslint @wordpress/no-global-event-listener: 0 */

import { intitalizeCarousels } from './carousels';
import { initializeNavigation } from './navigation';
import { initializeEmailSignup } from './forms/email-signup';

window.addEventListener('DOMContentLoaded', () => {
  initializeNavigation();
  initializeEmailSignup();
  intitalizeCarousels();
});
